
import React, { useState, useEffect } from 'react';
import {
  Layout,
  Menu,
  Card,
  Table,
  Button,
  Modal,
  Form,
  Input,
  InputNumber,
  Select,
  Space,
  Popconfirm,
  message,
  Row,
  Col,
  Statistic,
  Tag,
  Tabs,
  DatePicker,
  Upload,
  Switch,
  Divider,
  Badge,
  Typography,
  Drawer
} from 'antd';
import {
  ShoppingCartOutlined,
  AppstoreOutlined,
  TagsOutlined,
  GiftOutlined,
  DashboardOutlined,
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
  UploadOutlined,
  DollarOutlined,
  ShoppingOutlined,
  UserOutlined,
  BarChartOutlined
} from '@ant-design/icons';
import { discountService } from '../services';
import { useApiEnhanced } from '../hooks/useApiEnhanced';
import { toast } from 'react-toastify';

const { Header, Sider, Content } = Layout;
const { Option } = Select;
const { TextArea } = Input;
const { Title, Text } = Typography;
const { TabPane } = Tabs;

const DiscountsSection = () => {
  const { 
    data: discounts, 
    loading, 
    error, 
    execute: getDis 
  } = useApiEnhanced(
    (cred) => discountService.getDiscounts({page:1,size:50}),
    {immediate:true} // Load immediately
  );

    const { 
    data: updatedata, 
    loading:upLoading, 
    error:upError, 
    execute: updateDis 
  } = useApiEnhanced(
    (id,data) => discountService.updateDiscount(id,data),
    {immediate:false} // Load immediately
  );
   const { 
   
    error:delError, 
    execute: deleteDiscount 
  } = useApiEnhanced(
    (id,data) => discountService.deleteDiscount(id),
    {immediate:false} // Load immediately
  );

    const { 
    data: createdata, 
    loading:crLoading, 
    error:crError, 
    execute: createDiscount 
  } = useApiEnhanced(
    (data) => discountService.createDiscount(data),
    {immediate:false} // Load immediately
  );


  
  // const [discounts, setDiscounts] = useState([
  //   { key: '1', code: 'SUMMER20', type: 'Percentage', value: 20, minOrder: 50, status: 'Active', usageCount: 45 },
  //   { key: '2', code: 'FLAT10', type: 'Fixed', value: 10, minOrder: 30, status: 'Active', usageCount: 128 },
  //   { key: '3', code: 'WELCOME15', type: 'Percentage', value: 15, minOrder: 0, status: 'Active', usageCount: 234 },
  //   { key: '4', code: 'EXPIRED5', type: 'Percentage', value: 5, minOrder: 20, status: 'Expired', usageCount: 567 },
  // ]);
  const [modalVisible, setModalVisible] = useState(false);
  const [editingDiscount, setEditingDiscount] = useState(null);
  const [form] = Form.useForm();

  const columns = [
    { title: 'Code', dataIndex: 'code', key: 'code' },
    { title: 'Type', dataIndex: 'type', key: 'type' },
    {
      title: 'Value',
      key: 'value',
      render: (_, record) => (
        record.type === 'Percentage' ? `${record.value}%` : `₹${record.value}`
      ),
    },
    {
      title: 'Min Order',
      dataIndex: 'minOrderAmount',
      key: 'minOrderAmount',
      render: (minOrder) => `AED ${minOrder}`,
    },
    { title: 'Usage', dataIndex: 'usageCount', key: 'usageCount' },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => (
        <Tag color={status === 'Active' ? 'green' : 'red'}>{status}</Tag>
      ),
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Space>
          <Button icon={<EditOutlined />} onClick={() => handleEdit(record)} size="small">
            Edit
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this discount?"
            onConfirm={() => handleDelete(record._id)}
          >
            <Button icon={<DeleteOutlined />} danger size="small">
              Delete
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const handleEdit = (discount) => {
    setEditingDiscount(discount);
    form.setFieldsValue(discount);
    setModalVisible(true);
  };

  const handleDelete =async  (key) => {
   try {
     // setDiscounts(discounts.filter((d) => d.key !== key));
     let res = await deleteDiscount(key)
     if(!res?.success) return toast.error(res?.message||"Not deleted!")
      getDis()
    toast.success('Discount deleted successfully');
   } catch (error) {
    return toast.error("Not deleted!")
   }
  };

  const handleSubmit = async (values) => {
    try {
      
   
    if (editingDiscount) {
      // setDiscounts(discounts.map((d) => (d.key === editingDiscount.key ? { ...d, ...values } : d)));
      let res = await updateDis(editingDiscount._id,values)
      if(!res?.success) return toast.error('Discount not able to edit')
        getDis()
      toast.success('Discount updated successfully');
    } else {
      const newDiscount = { ...values, key: Date.now().toString(), usageCount: 0 };
      // setDiscounts([...discounts, newDiscount]);
      let res = await createDiscount(values)
     if(!res?.success) return toast.error('Discount not able to Create')
      getDis()
      toast.success('Discount added successfully');
    }
    setModalVisible(false);
    form.resetFields();
    setEditingDiscount(null);
     } catch (error) {
      
    }
  };

  return (
    <div>
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between' }}>
        <Title level={3}>Discounts Management</Title>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => {
            setEditingDiscount(null);
            form.resetFields();
            setModalVisible(true);
          }}
        >
          Add Discount
        </Button>
      </div>
      <Table columns={columns} dataSource={discounts?.data} />

      <Modal
        title={editingDiscount ? 'Edit Discount' : 'Add Discount'}
        visible={modalVisible}
        onCancel={() => {
          setModalVisible(false);
          form.resetFields();
          setEditingDiscount(null);
        }}
        footer={null}
      >
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Form.Item name="code" label="Discount Code" rules={[{ required: true }]}>
            <Input placeholder="Enter discount code" />
          </Form.Item>
          <Form.Item name="type" label="Discount Type" rules={[{ required: true }]}>
            <Select placeholder="Select discount type">
              <Option value="Percentage">Percentage</Option>
              <Option value="Fixed">Fixed Amount</Option>
            </Select>
          </Form.Item>
          <Form.Item name="value" label="Discount Value" rules={[{ required: true }]}>
            <InputNumber style={{ width: '100%' }} placeholder="Enter value" min={0} />
          </Form.Item>
          <Form.Item name="minOrderAmount" label="Minimum Order Amount" rules={[{ required: true }]}>
            <InputNumber style={{ width: '100%' }} placeholder="Enter minimum order amount" min={0} />
          </Form.Item>
          <Form.Item name="status" label="Status" rules={[{ required: true }]}>
            <Select placeholder="Select status">
              <Option value="Active">Active</Option>
              <Option value="Expired">Expired</Option>
            </Select>
          </Form.Item>
          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit">
                {editingDiscount ? 'Update' : 'Add'}
              </Button>
              <Button onClick={() => {
                setModalVisible(false);
                form.resetFields();
                setEditingDiscount(null);
              }}>
                Cancel
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default DiscountsSection